// extracted by mini-css-extract-plugin
export default {"Separator":"OfferStepsOverviewSeparator_Separator__bOVwi","Highlighted":"OfferStepsOverviewSeparator_Highlighted__zTANv"};